document.addEventListener('DOMContentLoaded', function () {
  const VIDEO_SELECTOR = '.product__media video, .media-gallery video, native-video video';

  function setBaseAttributes(video) {
    if (!video || video.dataset.onpulseVideoBase === 'true') return;
    video.dataset.onpulseVideoBase = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('muted', 'muted');
    video.setAttribute('autoplay', 'autoplay');
    video.setAttribute('loop', 'loop');
    video.setAttribute('playsinline', 'playsinline');
    video.setAttribute('webkit-playsinline', 'webkit-playsinline');
    video.setAttribute('disablepictureinpicture', 'true');
    video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
    video.style.pointerEvents = 'none';
  }

  function setPriority(video, isPriority) {
    if (!video) return;
    setBaseAttributes(video);

    if (isPriority) {
      video.dataset.onpulsePriority = 'true';
      video.setAttribute('preload', 'auto');
      video.setAttribute('fetchpriority', 'high');

      try {
        if (video.preload !== 'auto') video.preload = 'auto';
      } catch (e) {}

      const playNow = function () {
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {});
        }
      };

      if (video.readyState >= 2) {
        playNow();
      } else {
        video.addEventListener('canplay', playNow, { once: true });
        video.addEventListener('loadeddata', playNow, { once: true });
        try {
          video.load();
        } catch (e) {}
      }
    } else {
      delete video.dataset.onpulsePriority;
      video.removeAttribute('fetchpriority');
      video.setAttribute('preload', 'metadata');
      try {
        if (video.preload !== 'metadata') video.preload = 'metadata';
      } catch (e) {}
    }
  }

  function getPriorityMediaItem() {
    return document.querySelector(
      '.product__media-item.is-selected, .product__media-item.is-initial-selected, .product__media-item'
    );
  }

  function refreshProductMediaPriority() {
    const priorityItem = getPriorityMediaItem();
    const allVideos = document.querySelectorAll(VIDEO_SELECTOR);

    allVideos.forEach(function (video) {
      const mediaItem = video.closest('.product__media-item');
      const isPriority = !!priorityItem && mediaItem === priorityItem;
      setPriority(video, isPriority);
    });

    if (!priorityItem) return;

    const nativeVideo = priorityItem.querySelector('native-video');
    const inlineVideo = priorityItem.querySelector('video');

    if (inlineVideo) {
      setPriority(inlineVideo, true);
      return;
    }

    if (nativeVideo && typeof nativeVideo.play === 'function') {
      try {
        nativeVideo.play();
      } catch (e) {}
    }
  }

  function scan(root) {
    (root || document).querySelectorAll(VIDEO_SELECTOR).forEach(function (video) {
      setBaseAttributes(video);
    });
    refreshProductMediaPriority();
  }

  scan(document);
  window.addEventListener('load', refreshProductMediaPriority, { once: true });

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-media-id], [data-action="select"], .flickity-page-dots, .product__thumbnail-item');
    if (!trigger) return;
    requestAnimationFrame(refreshProductMediaPriority);
    setTimeout(refreshProductMediaPriority, 120);
  });

  const observer = new MutationObserver(function (mutations) {
    let shouldRefresh = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        shouldRefresh = true;
        return;
      }

      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches && node.matches(VIDEO_SELECTOR)) {
          setBaseAttributes(node);
          shouldRefresh = true;
        } else if (node.querySelectorAll) {
          node.querySelectorAll(VIDEO_SELECTOR).forEach(setBaseAttributes);
          shouldRefresh = true;
        }
      });
    });

    if (shouldRefresh) refreshProductMediaPriority();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-current']
  });
});
